/*
  ltt-lang-prompt — first-visit language chooser (Hamdi 2026-08-19b).

  Two jobs:
    1. On a shopper's FIRST visit, wait five seconds and offer the two
       languages. Once she answers, never ask again.
    2. On every later visit, put her back in the language she picked.

  Job 2 is the half that is easy to get wrong. The choice is remembered in
  localStorage, and if the page she lands on is in the other language we submit
  Shopify's own localization form for her stored locale — the same POST the
  header toggle uses, which preserves the path she asked for. A hand-built URL
  would have to guess the locale prefix and would break on `/`, `/ar`, search
  URLs with queries, and anything Shopify adds later.

  Guards, both deliberate:
    • the auto-switch runs AT MOST ONCE PER SESSION (sessionStorage). If the
      store ever stops serving the stored locale, the submit would land back on
      the same page and we would post forever. One shot per session turns an
      infinite loop into a single wasted request.
    • closing the card without choosing is also remembered. Someone who
      dismisses it is answering "don't ask me", and re-asking on every visit
      would be nagging.
*/
(function () {
  var KEY = 'ltt-lang-choice';
  var DISMISS = 'ltt-lang-dismissed';
  var SWITCHED = 'ltt-lang-switched';
  var DELAY = 5000;

  function store(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      /* private mode: the card simply asks again next time */
    }
  }

  function read(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function base(code) {
    return String(code || '').split('-')[0].toLowerCase();
  }

  function init() {
    var el = document.querySelector('[data-ltt-langprompt]');
    if (!el) return;

    var current = base(el.dataset.currentLocale);
    var chosen = read(KEY);

    /* ---- job 2: honour a choice already made ---- */
    if (chosen) {
      if (base(chosen) !== current && !sessionStorage.getItem(SWITCHED)) {
        var form = el.querySelector('[data-ltt-langprompt-choose="' + chosen + '"]');
        if (form && form.form) {
          try {
            sessionStorage.setItem(SWITCHED, '1');
          } catch (e) {}
          form.form.submit();
          return;
        }
      }
      return;
    }

    if (read(DISMISS)) return;

    /* ---- job 1: ask, once, after the page has had time to settle ---- */
    var timer = setTimeout(function () {
      el.hidden = false;
      /* next frame, so the transition has a start state to animate from */
      requestAnimationFrame(function () {
        el.classList.add('is-open');
      });
    }, DELAY);

    el.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-ltt-langprompt-choose]');
      if (choice) {
        var code = choice.getAttribute('data-ltt-langprompt-choose');
        store(KEY, code);
        /* Already reading this language? Then there is nothing to load — just
           close, rather than round-tripping the server for the same page. */
        if (base(code) === current) {
          event.preventDefault();
          close();
        }
        return;
      }
      if (event.target.closest('[data-ltt-langprompt-close]')) {
        store(DISMISS, '1');
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !el.hidden) {
        store(DISMISS, '1');
        close();
      }
    });

    function close() {
      clearTimeout(timer);
      el.classList.remove('is-open');
      /* wait out the transition before pulling it from the a11y tree */
      setTimeout(function () {
        el.hidden = true;
      }, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
